import React from "react";
import { usePlayerModal } from "../PlayerModalContext";
import { PickRoundMeta } from "./PickRoundMeta";
import { PlayerPickTrigger } from "./PlayerPickTrigger";

export function PlayerBreakdownSection({ moneyBreakdown, formatter }) {
    const { openPlayer } = usePlayerModal();
    return (
        <section
            aria-label="Player breakdown"
            className="player-breakdown space-y-4 text-masters-cream"
        >
            <h2 className="mb-2 border-b border-masters-moss/40 pb-2 text-xs font-semibold uppercase tracking-[0.2em] text-masters-goldmuted">
                Player breakdown
            </h2>
            {Object.keys(moneyBreakdown).map(function (keyName) {
                const row = moneyBreakdown[keyName];
                const underPar = parseInt(row.score, 10) < 0;
                const sortedPlayers = [...(row.players || [])].sort((a, b) => {
                    if (a.hasPlayedHoles === b.hasPlayedHoles) {
                        return (a.displayName || "").localeCompare(
                            b.displayName || "",
                        );
                    }
                    return a.hasPlayedHoles ? -1 : 1;
                });
                return (
                    <div
                        key={keyName}
                        className="rounded-xl border border-masters-moss/35 bg-masters-pine/30 p-4 shadow-md shadow-black/10"
                    >
                        <div className="mb-3 flex flex-row flex-wrap items-center gap-2 border-b border-masters-moss/25 pb-3">
                            <div className="w-9 shrink-0 rounded bg-masters-cream px-1 py-0.5 text-center text-sm font-bold text-masters-forest">
                                {keyName}
                            </div>
                            <div
                                className={`min-w-[2.5rem] shrink-0 rounded px-2 py-0.5 text-center text-sm font-semibold ${
                                    underPar
                                        ? "bg-rose-900/40 text-rose-100 ring-1 ring-rose-700/40"
                                        : "bg-masters-moss/50 text-masters-cream/90"
                                }`}
                            >
                                {row.score > 0 ? "+" : ""}
                                {row.score === 0 ? "E" : row.score}
                            </div>
                            <div className="ml-auto text-right text-sm font-medium text-masters-parchment">
                                ({row.sharedBetween}){" "}
                                {formatter.format(row.amountEach)}
                            </div>
                        </div>
                        <div className="space-y-2">
                            {sortedPlayers.map((player) => (
                                <div
                                    key={player.id || player.displayName}
                                    className="text-sm font-normal text-masters-cream/95"
                                >
                                    <PlayerPickTrigger
                                        ariaLabel={`Player details: ${player.displayName}`}
                                        onOpen={() =>
                                            openPlayer(player.displayName)
                                        }
                                    >
                                        <div className="flex items-center gap-3 rounded-lg py-0.5 text-left transition hover:bg-masters-pine/40">
                                            <div className="relative shrink-0">
                                                <img
                                                    className="h-12 w-12 rounded-full border border-masters-gold/20 object-cover"
                                                    alt=""
                                                    src={player.headshot?.href}
                                                />
                                                {player.flag?.href ? (
                                                    <img
                                                        src={player.flag.href}
                                                        alt={
                                                            player.flag.alt ?? ""
                                                        }
                                                        className="pointer-events-none absolute bottom-0 right-0 z-[1] h-3.5 w-auto min-w-[1.125rem] max-w-[1.5rem] translate-x-0.5 translate-y-0.5 rounded-[2px] border border-masters-moss/35 object-cover shadow-sm"
                                                    />
                                                ) : null}
                                            </div>
                                            <div className="min-w-0">
                                                <div>{player.displayName}</div>
                                                <PickRoundMeta
                                                    tone="dark"
                                                    className="mt-1"
                                                    thru={
                                                        player.roundThruLabel
                                                    }
                                                    roundGrossStrokes={
                                                        player.completedRoundGross
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </PlayerPickTrigger>
                                </div>
                            ))}
                        </div>
                    </div>
                );
            })}
        </section>
    );
}
